export default {
  id: null,
  name: null,
  slug: null,
  logo: null,
  powered_by_logo: null,
  powered_by_url: null,
  background: null,
  is_active: false,
  colors: {},
  divisions: [],
  track_taker_session: null,
  use_2FA: false,
  responsibleUsers: [],
  language_configuration: {},
};
